<template>
  <v-container>
    <v-card>
      <v-card-title class="bg-green-darken-2 text-white text-h6 d-flex justify-space-between align-center">
        <div>
          <v-icon start>mdi-phone</v-icon>
          Mensajes de Contáctanos
        </div>
        <v-btn color="white" variant="text" @click="fetchContactos">
          <v-icon left>mdi-refresh</v-icon>
          Actualizar
        </v-btn>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="contactos"
        :loading="loading"
        class="elevation-1"
      >
        <!-- Columna Acciones -->
        <template #item.actions="{ item }">
          <v-btn
            icon
            color="green"
            @click="abrirWhatsApp(item.telefono)"
            :disabled="!item.telefono"
          >
            <v-icon>mdi-whatsapp</v-icon>
          </v-btn>

          <v-btn icon color="blue" @click="copiarEmail(item.Email)">
            <v-icon>mdi-content-copy</v-icon>
          </v-btn>

          <v-menu transition="scale-transition" bottom left>
            <template #activator="{ props }">
              <v-btn icon v-bind="props" color="grey">
                <v-icon>mdi-message-text-outline</v-icon>
              </v-btn>
            </template>
            <v-card width="320">
              <v-card-title class="text-subtitle-2">
                Mensaje de {{ item.nombre }}
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text style="white-space: pre-wrap;">
                {{ item.motivo }}
              </v-card-text>
            </v-card>
          </v-menu>
        </template>

        <!-- Columna del Switch -->
        <template #item.vigente="{ item }">
          <v-chip
            :color="item.vigente ? 'green' : 'red'"
            class="text-white"
            size="small"
            @click="toggleVigente(item)"
            style="cursor:pointer"
          >
            {{ item.vigente ? "Si" : "No" }}
          </v-chip>
        </template>
      </v-data-table>

      <!-- Back to Panel -->
      <div class="text-center mt-6 mb-6">
        <v-btn
          to="/admin"
          variant="text"
          color="grey-darken-1"
          prepend-icon="mdi-arrow-left"
        >
          Volver al Panel
        </v-btn>
      </div>
    </v-card>
  </v-container>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue'
import { useStore } from 'vuex'

const store = useStore()

const loading = ref(false)

const headers = [
  { title: "ID", key: "id_contactos" },
  { title: "Nombre", value: "nombre" },
  { title: "Email", value: "mail" },
  { title: "Teléfono", value: "telefono" },
  { title: "Contactar", value: "vigente" },
  { title: "Acciones", value: "actions", sortable: false }
]

const contactos = computed(() => store.getters["contact/getAllContactos"])

const fetchContactos = async () => {
  loading.value = true
  const result = await store.dispatch("contact/fetchSubmissions")
  if (!result?.success) {
    console.error("Error cargando contactos:", result?.message)
  }
  loading.value = false
}

const abrirWhatsApp = (telefono) => {
  // 1. Validamos existencia
  if (!telefono) {
    alert("⚠️ No hay un número de teléfono disponible.")
    return
  }

  // 2. Convertimos a string y limpiamos caracteres no numéricos
  const limpio = telefono
    .toString()
    .normalize("NFKD") // elimina caracteres Unicode o raros
    .replace(/[^\d]/g, "") // deja solo números

  // 3. Validación básica de longitud (8 o más dígitos)
  if (limpio.length < 8) {
    alert(`⚠️ El número "${telefono}" no parece válido`)
    return
  }

  const url = `https://wa.me/${limpio}`
  window.open(url, "_blank")
}

const copiarEmail = (email) => {
  const mail = email ?? ""
  
  if (mail.trim() === "") {
    alert("⚠️ No hay un correo electrónico disponible para copiar.")
    return
  }

  navigator.clipboard.writeText(mail)
    .then(() => {
      alert(`📋 Email copiado: ${mail}`)
    })
    .catch(() => {
      alert("❌ No se pudo copiar el email al portapapeles.")
    })
}

const toggleVigente = async (item) => {
  const nuevoEstado = item.vigente ? 0 : 1
  await store.dispatch("contact/toggleVigente", { id: item.id_contactos, vigente: nuevoEstado })
}

onMounted(() => fetchContactos())
</script>